// source: https://github.com/basecamp/fizzy/blob/fizzy%409880570/app/javascript/controllers/hotkey_controller.js
// !!! changed private methods (starting with `#`) to protected (starting conventially with `_`) for overriding
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  click(event) {
    if (this._isClickable && !this._shouldIgnore(event)) {
      event.preventDefault()
      this.element.click()
    }
  }

  focus(event) {
    if (this._isClickable && !this._shouldIgnore(event)) {
      event.preventDefault()
      this.element.focus()
    }
  }

  _shouldIgnore(event) {
    return event.defaultPrevented || event.target.closest("input, textarea, lexxy-editor")
  }

  get _isClickable() {
    return getComputedStyle(this.element).pointerEvents !== "none"
  }
}
